import { Serializable } from "./serializable";

export class Tag implements Serializable<Tag> {
  id?: string;
  name?: string;
  code?: string;
  color?: string = "red";
  icon?: string;
  categoryId?: any;
  categoryName?: any;

  deserialize(input: any): Tag {
    if (input != null && input != undefined) {
      this.id = input.id;
      this.name = input.name || "";
      this.code = input.code || "";
      this.color = input.color || "#000";
      if (input.icon && input.icon.urls) {
        if (input.category.code == "mood") {
          // Per i mood, sostituisci .svg con .jpg nell'URL
          const originalUrl = input.icon.urls.original || "";
          this.icon = originalUrl.replace(/\.svg$/i, ".jpg");
        } else {
          this.icon = input.icon.urls.s;
        }
      }
      this.categoryId = input.category.id || null;
      this.categoryName = input.category.name || null;
    }
    return this;
  }
  deserializeV2(input: any): Tag {
    if (input != null && input != undefined) {
      this.name = input.name || "";
      this.code = input.code || "";
      this.id = input.id || null;
      this.color = input.color || "#000";
      if (input.icon && input.icon.urls) {
        this.icon = input.icon.urls.s;
      }
      this.categoryId = input.category ? input.category.code : null;
      this.categoryName = input.category ? input.category.name : null;
    }
    return this;
  }
}

export class CategoryTag implements Serializable<CategoryTag> {
  id?: string;
  name?: string;
  tags?: Tag[];
  code?: string;

  deserialize(input: any): CategoryTag {
    if (input != null) {
      this.id = input.id;
      this.name = input.name || "";
      if (input.tags && input.tags.length > 0) {
        this.tags = input.tags.map((tag: Tag) => new Tag().deserialize(tag));
      }
      this.code = input.code;
    }
    return this;
  }
}
